import React from 'react';
import styles from './ProverbCard.module.css';

interface Proverb {
  marathi: string;
  literal: string;
  idiomatic: string;
}

interface ProverbCardProps {
  proverb: Proverb;
  style?: React.CSSProperties;
  index?: number;
}

const ProverbCard: React.FC<ProverbCardProps> = ({ proverb, style, index }) => {
  const ariaLabel = index
    ? `Proverb ${index}: ${proverb.marathi}`
    : `Proverb: ${proverb.marathi}`;

  return (
    <article
      className={styles['proverb-card']}
      style={style}
      aria-label={ariaLabel}
    >
      <div className={styles['proverb-content']}>
        <div className={styles['proverb-marathi']} lang="mr">
          {proverb.marathi}
        </div>

        <div className={styles['proverb-translations']}>
          {proverb.literal && (
            <div className={styles['proverb-literal']}>
              <strong>Literal</strong>
              <span>{proverb.literal}</span>
            </div>
          )}
          {proverb.idiomatic && (
            <div className={styles['proverb-idiomatic']}>
              <strong>Meaning</strong>
              <span>{proverb.idiomatic}</span>
            </div>
          )}
        </div>
      </div>
    </article>
  );
};

export default ProverbCard;
